const vehicleCellErrorFilterMappings = {
  'vehicle.license_plate': {
    objectKey: 'vehicle',
    rules: [
      {
        errorValues: ['vehicle not found', 'value not found'],
        message: 'Kendaraan tidak terdaftar di master data kendaraan',
      },
      {
        errorValues: ['vehicle type does not match with vehicle type id'],
        message: 'Jenis kendaraan tidak sesuai dengan tipe kendaraan',
      },
    ],
  },
  'vehicle_type.name': {
    objectKey: 'vehicle_type',
    rules: [
      {
        errorValues: ['value not found'],
        message: 'Jenis kendaraan tidak terdaftar di pengaturan kendaraan',
      },
    ],
  },
  'driver_user.name': {
    objectKey: 'driver_user',
    rules: [
      {
        errorValues: ['value not found'],
        message: 'Pengemudi utama tidak terdaftar di master data',
      },
      {
        errorValues: ['driver user does not have category of the vehicle'],
        message: 'Pengemudi utama tidak sesuai kategori kendaraan',
      },
    ],
  },
  'driver_user_2.name': {
    objectKey: 'driver_user_2',
    rules: [
      {
        errorValues: ['value not found'],
        message: 'Pengemudi tambahan tidak terdaftar di master data',
      },
      {
        errorValues: ['driver user does not have category of the vehicle'],
        message: 'Pengemudi tambahan tidak sesuai kategori kendaraan',
      },
    ],
  },
}

export default vehicleCellErrorFilterMappings
